
	frappe.templates['sidebar_header'] = `
<a class="sidebar-header" style="text-decoration: none; width: auto;">
<div class="title-container">
    <div class="sidebar-item-label header-title" data-name-style="{%=frappe.boot.app_name_style%}">
            {%= __(workspace_title) %}
    </div>
</div>
</a>
`;
